module.exports = __webpack_public_path__ + "static/media/amex.e90e5a7b.svg";